<template>
  <transition
    @enter="enter"
    @leave="leave"
    class="dev-card"
  >
    <div
      ref="cardContainer"
      v-if="style && style !== undefined"
      v-show="active === Number(content.Name.replace('Plot ', ''))"
      class="absolute top-50 left-50 flex flex-column justify-between bg-white shadow-3 z-999 br2"
      style="width: 18.5em; height: 28rem; max-width: 18.5em; transform: translate(-50%, -50%)"
    >
      <div
        ref="closeButton"
        class="inset-box-shadow absolute br-100 ba bw2 b--white purple pointer"
        style="z-index: 1001; font-size: 0; top: -1.25rem; right: -1.25rem;"
        :class="'bg-' + calcTextColour(style.palette.key)"
        @click="$emit('select', 0)"
      >
        <svg
          width="2.5rem"
          height="2.5rem"
          viewBox="0 0 40 40"
          :fill="style.palette.dark"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 20C0 8.94 8.94 0 20 0C31.06 0 40 8.94 40 20C40 31.06 31.06 40 20 40C8.94 40 0 31.06 0 20ZM20 17.18L25.18 12L28 14.82L22.82 20L28 25.18L25.18 28L20 22.82L14.82 28L12 25.18L17.18 20L12 14.82L14.82 12L20 17.18Z"
          />
        </svg>
      </div>
      <div>
        <div
          ref="cardImg"
          class="aspect-ratio aspect-ratio--6x4 z-1 br--top br2"
        >
          <div
            class="aspect-ratio--object cover overflow-hidden br--top br2"
            :style="'background:url(' + style.featured_image + ') center'"
          />
        </div>
        <div
          ref="cardContent"
          class="ph3"
          style="padding-top: 20px"
        >
          <div
            class="mb3 fw6 f3 ttc"
            v-html="content.HouseType"
          />
          <div
            class="pb3"
            v-html="content.Name"
          />
          <div class="f6 mb3 lh-copy flex flex-wrap">
            <Pill
              class="b--purple-deep purple-deep mb2"
              :info="content.BedroomsCount + ' beds'"
            />
            <Pill
              class="mb2"
              :info="content.StatusCode"
            />
            <Pill
              v-if="content.Price && content.StatusCode === 'Available'"
              class="b--purple purple mb2"
              :info="content.Price | formatPrice"
            />
            <!-- {{ Intl.NumberFormat('en-US').format(style.size_sqm) }} m<sup>2</sup>
            <span class="ph2 black-50">/</span>
            {{ Intl.NumberFormat('en-US').format(style.size_sqft) }} ft<sup>2</sup> -->
          </div>
        </div>
      </div>
      <div
        ref="cardListed"
      >
        <router-link
          :to="$route.path + '/' + content.Name.substr(5)"
          class="f5 link dim dib tc w-100 br--bottom br2 pointer"
          :class="calcTextColour(style.palette.key)"
          style="padding: 0.75rem 0;"
          :style="'background-color: ' + style.palette.dark"
        >
          View Plot
        </router-link>
      </div>
    </div>
  </transition>
</template>

<script>
import Pill from '@/components/Pill'
import gsap from 'gsap'
const find = require('lodash/find')

export default {
  name: 'SitePlanCard',
  props: {
    active: {
      type: Number,
      default: null
    },
    content: {
      type: Object,
      default: null
    }
  },
  components: {
    Pill
  },
  data () {
    return {
      icon: {
        close: require('@/assets/img/off-close.svg')
      }
    }
  },
  computed: {
    style () {
      return find(this.$parent.development.styles, ['crm', this.content.HouseTypeId])
    }
  },
  methods: {
    statusColor (status) {
      switch (status) {
        case 'notReleased':
          return 'purple'
        case 'available':
          return 'green'
        case 'earlyBirdReserved':
          return 'orange'
        case 'sold':
          return 'pink'
        default:
          break
      }
    },
    close () {
      this.visible = false
    },
    calcTextColour (colourName) {
      const array = [
        'brightSun',
        'casablanca',
        'lima',
        'parisDaisy',
        'pictonBlue',
        'pinkSherbert',
        'prelude',
        'reef',
        'silverTree',
        'spray',
        'tropicalBlue',
        'vanillaIce'
      ]

      if (array.includes(colourName)) {
        return 'dark-gray'
      } else {
        return 'white'
      }
    },
    leave (el, done) {
      const card = this.$refs.cardContainer
      const content = this.$refs.cardContent
      const listedButtons = this.$refs.cardListed
      const close = this.$refs.closeButton
      gsap.fromTo([card, content.children, listedButtons],
        {
          opacity: 1
        },
        {
          opacity: 0,
          delay: 0,
          duration: 0.3,
          onComplete: done
        }
      )
      gsap.to(close,
        {
          scale: 0
        }
      )
    },
    enter (el, done) {
      const card = this.$refs.cardContainer
      const cardImg = this.$refs.cardImg
      const close = this.$refs.closeButton
      const content = this.$refs.cardContent
      const listedButtons = this.$refs.cardListed
      const tl = gsap.timeline({})
      tl.to([content.children, listedButtons],
        {
          opacity: 0
        }
      ).fromTo(card,
        {
          opacity: 0
        },
        {
          opacity: 1,
          duration: 0.2,
          delay: 0
        }
      ).fromTo(cardImg,
        {
          paddingBottom: 0 + '%'
        },
        {
          paddingBottom: 66 + '%',
          duration: 0.2,
          delay: 0
        }
      ).fromTo(card,
        {
          height: 63 + 'px',
          width: 72 + 'px'
        },
        {
          width: 18.5 + 'rem',
          height: 28 + 'rem',
          duration: 0.5
        }
      ).fromTo(listedButtons,
        {
          opacity: 0
        },
        {
          opacity: 1,
          delay: -0.1,
          duration: 0.2
        }
      ).fromTo(close,
        {
          scale: 0
        },
        {
          scale: 1,
          duration: 0.3,
          delay: -0.1,
          ease: 'back(1.7)'
        }
      ).fromTo(content.children,
        {
          opacity: 0,
          x: -10 + 'px'
        },
        {
          opacity: 1,
          x: 0 + 'px',
          stagger: 0.1,
          delay: 0.3,
          duration: 0.2,
          onComplete: done
        }
      )
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
  .scale-in-center {
    animation: scale-in-center 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
  }
  @keyframes scale-in-center {
    0% {
      transform: scale(0);
      opacity: 1;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
  .inset-box-shadow {
    -webkit-box-shadow:inset 0px 0px 0px 2px #FFF;
    -moz-box-shadow:inset 0px 0px 0px 2px #FFF;
    box-shadow:inset 0px 0px 0px 2px #FFF;
  }

</style>
